import { Button, Typography, makeStyles, Box } from '@material-ui/core';
import { useQuestionsStyles } from './DescribeQuestion';
import { useOnboardingStyles } from '../../onboarding/OnboardingDesignWrapper';
import { useCallback, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useSignUpStyles } from '../../../../pages/get-started';
import axios from 'axios';
import { setCookie } from './tools-common';
import moment from 'moment-timezone';
import { QuattrLogoSpinner } from './QuattrLogoSpinner';
import { get } from 'lodash';
import { useView } from '../../../utility/services/uiHelpers';
import { COMPONENT_NAMES, SCREEN_NAMES, trackAnalyticsEvent } from '../../../constants/analyticsMeta';
import {
  DAY_PASS_LITE_PLAN_ID,
  DAY_PASS_PLAN_ID,
  formatToEnUsDate,
  formatUnixDate,
  LITE_USD_MONTHLY,
  PRO_USD_MONTHLY,
  ULTRA_USD_MONTHLY,
  USER_CLASSIFICATION,
} from '../../../utility/common';
import { useSession } from '../../../utility/services/customHooks';
import { Router } from 'express';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { actionTypes } from '../../../constants/actionTypes';
import { signOut } from '../../../utility/services/authActions';

export const useBuyStyles = makeStyles((theme) => ({
  finalStepWrapper: {
    position: 'absolute',
  },
  buyPassSuccessWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buyBoxOuterHeader: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    paddingBottom: '16px',
  },
  subHeader: {
    overflow: 'hidden',
    color: '#1D3557',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  buyPassNow: {
    borderRadius: '4.2px',
    background: '#FFC72C',
    boxShadow: 'none',
    '&.MuiButton-containedPrimary:hover': {
      backgroundColor: '#FFC72C',
    },
  },
  conditions: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '108%',
  },
  orWait: {
    color: '#757575',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    margin: '24px auto 8px',
  },
  willGet: {
    overflow: 'hidden',
    color: '#757575',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  willWait: {
    borderRadius: '4.2px',
    border: '1px solid #757575',
    background: '#FFF',
    color: '#757575',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '108%',
  },
  successActionBox: {
    background: '#F6F7F9',
    width: '679px',
    padding: '24px',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  celebrateImage: {
    width: '108.969px',
    height: '113.862px',
  },
  SpecialDiscount: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    position: 'absolute',
    width: '135px',
    height: '11px',
    top: '5px',
    color: '#f25f5c',
    fontFamily: 'Poppins, var(--default-font-family)',
    fontSize: '8px',
    fontWeight: 700,
    lineHeight: '11px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    zIndex: 3,
  },
  strikethroughPrice: {
    position: 'relative',
    color: '#979797',
    fontFamily: 'Poppins, var(--default-font-family)',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '36px',
    textAlign: 'center',
  },

  dividerTextOr: {
    padding: '10px 20px',
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
  },
  dividerTextDescription: {
    color: '#1D3557',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
  },
}));

interface Plan {
  plan_id: string;
  link: string;
  plan_name: string;
  unit_price: string;
}

export const BuyOnePass = (props) => {
  const [showRequestLoader, setShowRequestLoader] = useState(false);
  const [allPlanLinks, setAllPlanLinks] = useState<Plan[]>([]);
  const [dayPassLink, setDayPassLink] = useState<any>({});
  const [nativeModel, setNativeModel] = useState(false);
  const [isDirectBuyPassPage, setIsDirectBuyPassPage] = useState(false);
  const [isToolUser, setIsToolUser] = useState(false);
  const { session } = useSession();
  let qttr_tools_daypass_auth = Cookies.get('qttr_tools_daypass_auth');
  let qttr_tools_auth = Cookies.get('qttr_tools_auth');
  const questionStyles = useQuestionsStyles();
  const buyStyles = useBuyStyles();
  const signupStyles = useSignUpStyles();
  const onboardingStyles = useOnboardingStyles();
  const router = useRouter();
  const isMobile = useView('mobileOnly', true);
  const [timeLeft, setTimeLeft] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (session?.user?.userType === USER_CLASSIFICATION.QWA_TOOLS) {
      setIsToolUser(true);
    }
    let timeoutId;
    const searchParams = window.parent.location.search;
    let qttr_tools_auth = Cookies.get('qttr_tools_auth');
    let qttr_tools_daypass_auth = Cookies.get('qttr_tools_daypass_auth');

    if (!searchParams) {
      timeoutId = setTimeout(() => {
        const searchParams = window.parent.location.search;
        const queryParams = new URLSearchParams(searchParams);
        const isBuyPass = queryParams.get('buyPass');
        if (isBuyPass && qttr_tools_auth && !showRequestLoader && !qttr_tools_daypass_auth) {
          setIsDirectBuyPassPage(true);
          // handleGetCheckoutPage();
        }
      }, 500);
    }
    const queryParams = new URLSearchParams(searchParams);
    const isBuyPass = queryParams.get('buyPass');
    if (isBuyPass && qttr_tools_auth && !showRequestLoader && !qttr_tools_daypass_auth) {
      setIsDirectBuyPassPage(true);
      // handleGetCheckoutPage();
    }
  }, []);

  //for paid tool timer that we are showing
  useEffect(() => {
    const calculateTimeUntilMidnight = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0); // Set time to midnight

      return midnight.getTime() - now.getTime(); // Calculate difference in milliseconds
    };

    const formatTimeLeft = (milliseconds) => {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds
        .toString()
        .padStart(2, '0')}s`;
    };

    const scheduleMidnightFunction = () => {
      const timeUntilMidnight = calculateTimeUntilMidnight();
      setTimeLeft(formatTimeLeft(timeUntilMidnight));

      const countdownInterval = setInterval(() => {
        const newTimeUntilMidnight = calculateTimeUntilMidnight();
        setTimeLeft(formatTimeLeft(newTimeUntilMidnight));

        if (newTimeUntilMidnight <= 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);
    };

    scheduleMidnightFunction();
  }, []); // Empty dependency array to run effect only once on mount

  useEffect(() => {
    if (!qttr_tools_daypass_auth) {
      trackAnalyticsEvent({
        eventName: props?.isQwaDashboard
          ? 'Prompted DayPass and Upgrade Plan Banner'
          : 'Prompted Webflow Purchase Banner',
        payload: {
          label: props?.isQwaDashboard
            ? 'Prompted DayPass and Upgrade Plan Banner'
            : 'Prompted Webflow Purchase Banner',
          component_name: COMPONENT_NAMES.contentai_ai_tools,
          screen_name: SCREEN_NAMES.contentai_ai_tools,
          ...(props.toolMeta || {}),
          isQwaDashboard: props?.isQwaDashboard,
        },
      });
      handleGetAllLinks();
    } else {
      // have day pass token but no usage left
      const searchParams = window.parent.location.search;
      const queryParams = new URLSearchParams(searchParams);
      const isBuyPass = queryParams.get('buyPass');
      handleGetAllLinks(isBuyPass ? false : true);
    }
  }, []);

  const launchDayPassPurchasePage = (data, showExpired = false) => {
    if (data) {
      const urlsObj = {};
      const dayPassId = DAY_PASS_PLAN_ID;
      const dayPassObj = data.find((i) => i.plan_id == dayPassId);

      if (dayPassObj) {
        urlsObj['dayPass'] = dayPassObj?.link;
      }

      const dayPassLiteObj = data.find((i) => i.plan_id == DAY_PASS_LITE_PLAN_ID);
      if (dayPassLiteObj) {
        urlsObj['dayPassLite'] = dayPassLiteObj?.link;
      }

      const toolsPlanLiteMonthlyObj = data.find((i) => i.plan_id == LITE_USD_MONTHLY);
      if (toolsPlanLiteMonthlyObj) {
        urlsObj['toolsLiteUsdMonthly'] = toolsPlanLiteMonthlyObj?.link;
      }
      const toolsPlanProMonthlyObj = data.find((i) => i.plan_id == PRO_USD_MONTHLY);
      if (toolsPlanProMonthlyObj) {
        urlsObj['toolsProUsdMonthly'] = toolsPlanProMonthlyObj.link;
      }
      const toolsPlanUltraMonthlyObj = data.find((i) => i.plan_id == ULTRA_USD_MONTHLY);
      if (toolsPlanUltraMonthlyObj) {
        urlsObj['toolsUltraUsdMonthly'] = toolsPlanUltraMonthlyObj?.link;
      }

      const toolsIframeComponent = window.parent.document.querySelector('[qttr-id="Tools iframe"]');
      const webflowComponentWithToolsPurchaseAndDayPass = window.parent.document.querySelector(
        '[qttr-id="Webflow Purchase Block"]'
      );

      if (toolsIframeComponent && webflowComponentWithToolsPurchaseAndDayPass) {
        (toolsIframeComponent as HTMLElement).style.display = 'none';
        (webflowComponentWithToolsPurchaseAndDayPass as HTMLElement).style.display = 'flex';

        const dayPassBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[data-prop-label="Buy Day Pass"]'
        );
        if (dayPassBtn && dayPassObj) {
          (dayPassBtn as HTMLAnchorElement).href = dayPassObj?.link;
        }
        const litePlanBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Btn Buy AI Tools Lite Plan"]'
        );
        if (litePlanBtn && toolsPlanLiteMonthlyObj) {
          (litePlanBtn as HTMLAnchorElement).href = toolsPlanLiteMonthlyObj?.link;
        }
        const proPlanBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Btn Buy AI Tools Pro Plan"]'
        );
        if (proPlanBtn && toolsPlanProMonthlyObj) {
          (proPlanBtn as HTMLAnchorElement).href = toolsPlanProMonthlyObj?.link;
        }
        const ultraPlanBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Btn Buy AI Tools Ultra Plan"]'
        );
        if (ultraPlanBtn && toolsPlanUltraMonthlyObj) {
          (ultraPlanBtn as HTMLAnchorElement).href = toolsPlanUltraMonthlyObj?.link;
        }

        const lockedOptionText = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Lock Option"]');
        const thankYouForVerifying = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Verification Complete Heading"]'
        );
        const maxUsageLimitMsg = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Usage Limit Reached"]'
        );
        const verificationCompleteBody = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Verification Complete Body"]'
        );
        const planExpiredMessage =
          webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Day Pass Expired"]');
        const emailSetting = webflowComponentWithToolsPurchaseAndDayPass.querySelector(
          '[qttr-id="Usage Limit Reached email settings"]'
        );

        const goBackAndContinueElements = webflowComponentWithToolsPurchaseAndDayPass?.querySelectorAll(
          '[qttr-id="Go back & continue"]'
        );

        if (goBackAndContinueElements) {
          goBackAndContinueElements.forEach((element) => {
            const span = element.querySelector('span');
            if (span && !span.getAttribute('data-event-attached')) {
              span.addEventListener('click', () => {
                (webflowComponentWithToolsPurchaseAndDayPass as HTMLElement).style.display = 'none';
                (toolsIframeComponent as HTMLElement).style.display = 'block';
                props?.handleWait();
                trackAnalyticsEvent({
                  eventName: 'Clicked on Go back & Continue',
                  payload: {
                    label: 'Clicked on Go back & Continue',
                    ...(props.toolMeta || {}),
                  },
                });
              });
              // Mark the span as having an event listener attached
              span.setAttribute('data-event-attached', 'true');
            }
          });
        }

        if (props?.isRedirectToWebflow && goBackAndContinueElements) {
          if (lockedOptionText) {
            (lockedOptionText as HTMLElement).style.display = 'none';
          }
          if (planExpiredMessage) {
            (planExpiredMessage as HTMLElement).style.display = 'none';
          }
          if (maxUsageLimitMsg) {
            (maxUsageLimitMsg as HTMLElement).style.display = 'none';
          }
          if (emailSetting) {
            (emailSetting as HTMLElement).style.display = 'none';
          }
          goBackAndContinueElements.forEach((element) => {
            (element as HTMLElement).style.display = 'block';
          });
        } else {
          if (goBackAndContinueElements && goBackAndContinueElements[1]) {
            (goBackAndContinueElements[1] as HTMLElement).style.display = 'none';
          }
        }

        if (lockedOptionText && props.isFromUnlockOption) {
          // if clicked on locked option
          (lockedOptionText as HTMLElement).style.display = 'flex';

          if (planExpiredMessage) {
            (planExpiredMessage as HTMLElement).style.display = 'none';
          }
          if (maxUsageLimitMsg) {
            (maxUsageLimitMsg as HTMLElement).style.display = 'none';
          }
          if (emailSetting) {
            (emailSetting as HTMLElement).style.display = 'none';
          }
          if (goBackAndContinueElements && goBackAndContinueElements[1]) {
            (goBackAndContinueElements[1] as HTMLElement).style.display = 'none';
          }
        }

        if (props?.verifiedEmailHere && !props?.isFromUnlockOption) {
          //after email verification not showing default popup messages if all limits exost

          if (webflowComponentWithToolsPurchaseAndDayPass && toolsIframeComponent) {
            (webflowComponentWithToolsPurchaseAndDayPass as HTMLElement).style.display = 'none';
            (toolsIframeComponent as HTMLElement).style.display = 'block';
            props?.handleWait();
          }
        } else {
          if (thankYouForVerifying) {
            (thankYouForVerifying as HTMLElement).style.display = 'none';
          }
          if (verificationCompleteBody) {
            (verificationCompleteBody as HTMLElement).style.display = 'none';
          }
          if (emailSetting) {
            (emailSetting as HTMLElement).style.display = 'none';
          }
        }

        if (maxUsageLimitMsg && !props.verifiedEmailHere && qttr_tools_auth && props.isReachedMaxLimit) {
          //for max usage limit reached.
          (maxUsageLimitMsg as HTMLElement).style.display = 'flex';
          if (emailSetting) {
            (emailSetting as HTMLElement).style.display = 'flex';
          }
          if (lockedOptionText) {
            (lockedOptionText as HTMLElement).style.display = 'none';
          }
          if (planExpiredMessage) {
            (planExpiredMessage as HTMLElement).style.display = 'none';
          }
        }

        if (planExpiredMessage && showExpired) {
          //for daypass expired message
          (planExpiredMessage as HTMLElement).style.display = 'flex';
          if (lockedOptionText) {
            (lockedOptionText as HTMLElement).style.display = 'none';
          }
          if (verificationCompleteBody) {
            (verificationCompleteBody as HTMLElement).style.display = 'none';
          }
          if (thankYouForVerifying) {
            (thankYouForVerifying as HTMLElement).style.display = 'none';
          }
          if (maxUsageLimitMsg) {
            (maxUsageLimitMsg as HTMLElement).style.display = 'none';
          }
          if (emailSetting) {
            (emailSetting as HTMLElement).style.display = 'none';
          }
        }
      } else {
        setNativeModel(true);
      }
      console.log('set all elements');
      // window.parent.postMessage({ action: 'prompt_day_pass_plans', urls: urlsObj }, '*');
    }
  };

  const sendSlackMessageIfFails = async (error, email) => {
    try {
      const isPlainObject = (obj) => {
        return Object.prototype.toString.call(obj) === '[object Object]';
      };
      const fields = [
        {
          title: 'Error Message',
          value: error.message || 'Unknown error',
          short: false,
        },
        {
          title: 'Stack Trace',
          value: `\`\`\`${error.stack || 'No stack trace available'}\`\`\``,
          short: false,
        },
        {
          title: 'User Email',
          value: email || 'No email provided',
          short: false,
        },
      ];

      if (error.response) {
        fields.push({
          title: 'Response Status',
          value: `${error.response.status}`,
          short: true,
        });

        if (isPlainObject(error.response.data)) {
          fields.push({
            title: 'Response Data',
            value: `\`\`\`${JSON.stringify(error.response.data, null, 2)}\`\`\``,
            short: false,
          });
        } else if (typeof error.response.data === 'string' && !error.response.data.startsWith('<')) {
          fields.push({
            title: 'Response Data',
            value: `\`\`\`${error.response.data}\`\`\``,
            short: false,
          });
        }
      } else if (error.request) {
        fields.push({
          title: 'Request',
          value: `\`\`\`${JSON.stringify(error.request, null, 2)}\`\`\``,
          short: false,
        });
      }
      const payload = {
        text: `Error getting tools daypass plans and checkout links :: method => handleGetAllLinks`,
        attachments: [
          {
            color: 'danger',
            fields: fields,
          },
        ],
      };
      await axios.post('/api/post_slack_message', { payload: payload });
    } catch (error: any) {
      const payload = {
        text: `Error sending slack message on get all daypass link fail`,
        attachments: [
          {
            color: 'danger',
            fields: [
              {
                title: 'Error Message',
                value: error.message || 'Unknown error',
                short: false,
              },
            ],
          },
        ],
      };
      console.error('Error :: sending slack message on get all daypass link fail');
      await axios.post('/api/post_slack_message', { payload: payload });
    }
  };

  const sanitizeBase64String = (base64String) => base64String.replace(/[^A-Za-z0-9+/=]/g, '');

  const decodeBase64 = (encodedString) => {
    try {
      return JSON.parse(atob(encodedString));
    } catch (error) {
      console.error('Error decoding base64:');
      return null;
    }
  };

  const getPayloadBody = (email, firstName, lastName, isRedirectToWebflow = false) => ({
    email,
    firstName,
    lastName,
    redirect_url: `${window.parent.location.origin}${window.parent.location.pathname}`,
    tools_plan_redirect_url: `${window.parent.location.origin}/get-started?tab=start-free-trial`,
    isRedirectToWebflow,
  });

  const handleGetAllLinks = async (showExpired = false) => {
    let cookieEmail = '';
    try {
      let qttr_tools_auth = Cookies.get('qttr_tools_auth');
      if (qttr_tools_auth || session || props.isRedirectToWebflow) {
        if (allPlanLinks?.length) {
          launchDayPassPurchasePage(allPlanLinks, showExpired);
          return;
        }
        let payloadBody = {};

        if (session?.user?.email) {
          payloadBody = getPayloadBody(
            session.user.email,
            session.user.name?.split(' ')[0] || '',
            session.user.name?.split(' ')[session?.user?.name?.split(' ')?.length - 1] || ''
          );
        } else if (qttr_tools_auth && !session?.user?.email) {
          const [headerEncoded, payloadEncoded] = qttr_tools_auth?.split('.') || [];
          const sanitizedPayloadEncoded = sanitizeBase64String(payloadEncoded);

          const payload = decodeBase64(sanitizedPayloadEncoded);
          if (payload) {
            cookieEmail = payload?.email;
            payloadBody = getPayloadBody(payload?.email || '', payload?.firstName || '', payload?.lastName || '');
          } else {
            payloadBody = getPayloadBody('', '', '', true);
          }
        } else {
          payloadBody = getPayloadBody('', '', '', true);
        }

        const res = await axios.post('/api/join-content-ai/get-tool-plans-links', payloadBody, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        setAllPlanLinks(res.data.data);
        const dayPassLinksFiltered = res.data.data.filter((item) => item.plan_id.includes('Day-Pass-Lite'));
        setDayPassLink(dayPassLinksFiltered?.[0]);
        launchDayPassPurchasePage(res.data.data, showExpired);
      }
    } catch (error: any) {
      console.error('handleGetCheckoutPage');

      if (
        [403, 401].includes(error?.response?.status) &&
        ['Requires Authentication', 'Access Denied!!!'].includes(error?.response?.data)
      ) {
        await signOut({ callbackUrl: '/login', redirect: true });
        trackAnalyticsEvent({
          eventName: 'Logged out due to session expiry',
          payload: {
            label: 'Logged out due to session expiry',
            methodCalled: 'getCreditsRemaining::tools',
          },
        });
      } else {
        sendSlackMessageIfFails(error, session?.user?.email ? session.user.email : cookieEmail ? cookieEmail : '');
        trackAnalyticsEvent({
          eventName: 'Encountered Error While Fetching Checkout Page Link',
          payload: {
            label: 'Encountered Error While Fetching Checkout Page Link',
            email: session?.user ? session.user.email : cookieEmail ? cookieEmail : '',
            isQwaDashboard: props?.isQwaDashboard,
            errorMsg: error?.response?.data?.errorMsg ?? 'Error Fetching Checkout links',
            errorData: error?.response?.data?.data ?? 'Error Fetching Checkout links',
            error: error,
          },
        });
      }
    }
  };

  if (!nativeModel) {
    return <QuattrLogoSpinner classes={{}} />;
  }
  return (
    <div className={props?.isQwaDashboard ? questionStyles.qwaFormWrapper : ''}>
      <div className={questionStyles.questionsWrapper} style={{ background: '#F6F7F9' }}>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <span
            style={{ fontFamily: 'poppins', fontSize: '18px', color: '#F25F5C', fontWeight: 700, maxWidth: '450px' }}
          >
            {props?.showMinimumCreditsNeededMsg
              ? 'Oops.. You do not have the minimum credits needed to generate output'
              : !session?.user?.planId || !qttr_tools_daypass_auth
              ? 'You have reached your maximum usage limit'
              : 'You have consumed your daily credits'}
          </span>
        </div>

        <p style={{ maxWidth: '620px', fontSize: '14px' }}>
          You can either purchase more credits via a Day Pass or Upgrade to a plan with higher daily credit limits.{' '}
        </p>

        {dayPassLink ? (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '640px',
              margin: 'auto',
              gap: '10px',
              flexDirection: isMobile ? 'column' : 'row',
            }}
          >
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={showRequestLoader}
              className={`${signupStyles.signUpButton} ${signupStyles.dynamicWidthBtn} ${signupStyles.largeCTA} ${buyStyles.buyPassNow}`}
              onClick={() => {
                trackAnalyticsEvent({
                  eventName: 'ButtonClick - Buy Day Pass',
                  payload: {
                    label: 'ButtonClick - Buy Day Pass',
                  },
                });
                window.location.href = dayPassLink?.link;
              }}
              style={{ padding: '43px 10px' }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography style={{ fontSize: '18px', fontWeight: '700', color: '#1D3557' }}>
                  {showRequestLoader ? (
                    <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                      <path id="one" d="M5,25H0V0h5V25z" />
                      <path id="two" d="M15,25h-5V0h5V25z" />
                      <path id="three" d="M25,25h-5V0h5V25z" />
                    </svg>
                  ) : null}
                  {showRequestLoader
                    ? 'Please wait...'
                    : props.isSubscriptionExpired
                    ? `Buy $0.99 USD Day Pass Again`
                    : `Buy $0.99 USD Day Pass`}
                  {!showRequestLoader ? <sup>#</sup> : null}
                </Typography>
                <Typography style={{ fontSize: '14px', fontWeight: '600', color: '#1D3557' }}>
                  Get 20 Additional Credits<sup>*</sup>
                </Typography>
              </div>
            </Button>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={showRequestLoader}
              className={`${signupStyles.signUpButton} ${signupStyles.dynamicWidthBtn} ${signupStyles.largeCTA} ${buyStyles.buyPassNow}`}
              onClick={() => {
                trackAnalyticsEvent({
                  eventName: 'ButtonClick - Upgrade Plan',
                  payload: {
                    label: 'ButtonClick - Upgrade Plan',
                    isQwaDashboard: props?.isQwaDashboard,
                  },
                });
                router.push('/app/add-credits');
              }}
              style={{ padding: '43px 10px' }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography style={{ fontSize: '18px', fontWeight: '700', color: '#1D3557' }}>
                  {showRequestLoader ? (
                    <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                      <path id="one" d="M5,25H0V0h5V25z" />
                      <path id="two" d="M15,25h-5V0h5V25z" />
                      <path id="three" d="M25,25h-5V0h5V25z" />
                    </svg>
                  ) : null}
                  {showRequestLoader ? 'Please wait...' : 'Upgrade Plan'}
                </Typography>
                <Typography style={{ fontSize: '14px', fontWeight: '600', color: '#1D3557' }}>
                  Get more daily credits
                </Typography>
              </div>
            </Button>
          </Box>
        ) : (
          <Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={showRequestLoader}
            className={`${signupStyles.signUpButton} ${signupStyles.dynamicWidthBtn} ${signupStyles.largeCTA} ${buyStyles.buyPassNow}`}
            onClick={() => {
              trackAnalyticsEvent({
                eventName: 'ButtonClick - Upgrade Plan',
                payload: {
                  label: 'ButtonClick - Upgrade Plan',
                  isQwaDashboard: props?.isQwaDashboard,
                },
              });
              router.push('/app/add-credits');
            }}
            style={{ padding: '43px 10px' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography style={{ fontSize: '18px', fontWeight: '700', color: '#1D3557' }}>
                {showRequestLoader ? (
                  <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                    <path id="one" d="M5,25H0V0h5V25z" />
                    <path id="two" d="M15,25h-5V0h5V25z" />
                    <path id="three" d="M25,25h-5V0h5V25z" />
                  </svg>
                ) : null}
                {showRequestLoader ? 'Please wait...' : 'Upgrade Plan'}
              </Typography>
              <Typography style={{ fontSize: '14px', fontWeight: '600', color: '#1D3557' }}>
                Get more daily credits
              </Typography>
            </div>
          </Button>
        )}

        <Typography className={buyStyles.conditions}>
          <sup>#</sup>One day pass is valid for 24 hours. No auto-renewal.
          <br />
          *Fair usage policy applies. Read{' '}
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => {
              window.open('/content-ai/terms');
            }}
          >
            terms of use{' '}
          </span>{' '}
          for more.
        </Typography>
        {session?.user?.planId && !qttr_tools_daypass_auth ? (
          <>
            <Typography component={'h4'} className={buyStyles.dividerTextOr}>
              OR
            </Typography>
            <Typography component={'h4'} className={buyStyles.dividerTextDescription}>
              Wait for {timeLeft} until your credits reset.
            </Typography>
          </>
        ) : !session?.user?.planId && !qttr_tools_daypass_auth ? (
          <>
            <Typography component={'h4'} className={buyStyles.dividerTextOr}>
              OR
            </Typography>
            <Typography component={'h4'} className={buyStyles.dividerTextDescription}>
              Wait for the next 8 hours until your credits reset.
            </Typography>
          </>
        ) : null}
      </div>
      {props.isSubscriptionExpired ? (
        <Typography
          onClick={() => {
            if (props.handleContinue) {
              props.handleContinue();
            }
            trackAnalyticsEvent({
              eventName: 'Clicked on Continue',
              payload: {
                label: 'Clicked on Continue',
                ...(props.toolMeta || {}),
              },
            });
          }}
          className={buyStyles.willGet}
          style={{ cursor: 'pointer', fontSize: '12px', marginTop: '20px' }}
        >
          OR Get 7 credits every 8 hours for free. Best for occasional use.
        </Typography>
      ) : null}
      {!isDirectBuyPassPage && !props.isFromUnlockOption && props.verifiedEmailHere && props.handleWait && (
        <>
          <Typography className={buyStyles.orWait}>OR Access Tools for Free with Usage Limits</Typography>
          <Typography className={buyStyles.willGet}>
            For a limited time, verified accounts get 7 credits every 8 hours for free. <br />
            Generate up to 7 credits for free, then wait 8 hours before you can use more. <br /> This waiting period
            ensures fair access to our tools for all users.
          </Typography>

          <Typography
            onClick={() => {
              if (props.handleWait) {
                props.handleWait();
              }
              trackAnalyticsEvent({
                eventName: 'Clicked on Continue',
                payload: {
                  label: 'Clicked on Continue',
                  ...(props.toolMeta || {}),
                },
              });
            }}
            className={buyStyles.orWait}
            style={{ cursor: 'pointer', fontSize: '12px', marginTop: '20px', textDecoration: 'underline' }}
          >
            Continue
          </Typography>
        </>
      )}
    </div>
  );
};

export const BuyOnePassSuccess = ({ handleContinue, toolMeta, isQwaDashboard = false }) => {
  const questionStyles = useQuestionsStyles();
  const [showRequestLoader, setShowRequestLoader] = useState(false);
  const { session } = useSession();
  const [dayPassPurchaseVerified, setDayPassPurchaseVerified] = useState(false);
  const [isSubscriptionExpired, setIsSubscriptionExpired] = useState(false);
  const [verificationFailed, setVerificationFailed] = useState(false);
  const [validTillDate, setValidTillDate] = useState('');
  const [plan_id, setPlanId] = useState('');
  const [tz, setTz] = useState('');

  const buyStyles = useBuyStyles();
  const isMobile = useView('mobileOnly', true);
  function formatDate(dateString) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(dateString);

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
  const getTimeZone = () => {
    const timezone = moment.tz.guess(); // Guess the user's time zone
    const time = moment.tz(new Date(), timezone); // Create a moment object with the user's timezone
    return time.format('z'); // Prints the timezone abbreviation, such as IST
  };

  const VerifyUserPurchase = async (planId) => {
    try {
      let qttr_tools_auth = Cookies.get('qttr_tools_auth');
      if (qttr_tools_auth || session) {
        setShowRequestLoader(true);
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let payloadBody = {};
        if (qttr_tools_auth) {
          const [headerEncoded, payloadEncoded, signatureEncoded] = qttr_tools_auth.split('.');
          const payload = JSON.parse(atob(payloadEncoded));
          payloadBody = {
            email: payload.email,
            firstName: payload.firstName,
            lastName: payload.lastName,
            timezone,
            plan_id: planId,
            isQwaDashboard: isQwaDashboard,
          };
        } else {
          payloadBody = {
            email: session?.user.email,
            firstName: session?.user.name?.split(' ')[0] || '',
            lastName: session?.user.name?.split(' ')[1] || '',
            timezone,
            plan_id: planId,
            isQwaDashboard: isQwaDashboard,
          };
        }
        // Decode the base64-encoded payload
        const res = await axios.post('/api/join-content-ai/verify-day-pass-purchased', payloadBody, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (res?.data?.data && res?.data?.data?.id) {
          if (!dayPassPurchaseVerified) {
            setDayPassPurchaseVerified(true);
            setValidTillDate(formatDate(res?.data?.data.expires_at));
            setPlanId(planId);
            trackAnalyticsEvent({
              eventName: `Purchase Verified (${res?.data?.data?.description}) & Activated Successfully`,
              payload: {
                plan_id: planId,
                label: `Purchase Verified (${res?.data?.data?.description}) & Activated Successfully`,
                ...(toolMeta || {}),
              },
            });

            trackAnalyticsEvent({
              eventName: `Revenue tracking - DayPass`,
              payload: {
                isQwaDashboard: isQwaDashboard,
                userDetails: payloadBody,
                plan_id: planId,
                $productId: planId,
                $price: res?.data?.data?.amount / 100,
                $revenue: res?.data?.data?.amount / 100,
                $currency: 'USD', // or the appropriate currency
                $revenueType: 'DayPass', // optional
                validTillDate: formatToEnUsDate(res?.data?.data?.expires_at),
                datePurchased: formatUnixDate(res?.data?.data?.purchaseDateInSeconds),
                label: `Revenue tracking - DayPass Purchase`,
                ...(toolMeta || {}),
              },
            });
          }
        }
      }
    } catch (error) {
      if (
        typeof get(error, 'response.data.data') === 'string' &&
        (get(error, 'response.data.data') as string | undefined)?.includes('Expired')
      ) {
        trackAnalyticsEvent({
          eventName: 'Prompted As: Your Day Plan has Expired!',
          payload: {
            label: 'Prompted As: Your Day Plan has Expired!',
            ...(toolMeta || {}),
          },
        });
        setIsSubscriptionExpired(true);
      } else {
        setVerificationFailed(true);
        trackAnalyticsEvent({
          eventName: 'Prompted As: Something Went Wrong!',
          payload: {
            label: 'Prompted As: Something Went Wrong!',
            error: get(error, 'response.data.data'),
            ...(toolMeta || {}),
          },
        });
      }
      setShowRequestLoader(false);
      console.error('VerifyUserPurchase::');
    }
  };

  useEffect(() => {
    let timeoutId;
    const searchParams = window.parent.location.search;
    let qttr_tools_auth = Cookies.get('qttr_tools_auth');

    if (!searchParams) {
      timeoutId = setTimeout(() => {
        const searchParams = window.parent.location.search;
        const queryParams = new URLSearchParams(searchParams);
        const planId = queryParams.get('plan_id');
        if (qttr_tools_auth || session) {
          VerifyUserPurchase(planId);
          // handleGetCheckoutPage();
        }
      }, 500);
    }
    const queryParams = new URLSearchParams(searchParams);
    const planId = queryParams.get('plan_id');
    if (qttr_tools_auth || session) {
      VerifyUserPurchase(planId);
      // handleGetCheckoutPage();
    }
    const timezone = getTimeZone();
    if (timezone) {
      setTz(timezone);
    }
  }, [session]);
  useEffect(() => {
    const Iframe = window.parent.document.querySelector('[qttr-id="quattrai-tools-frame"]');
    if (isMobile && Iframe) {
      Iframe.scrollIntoView();
      window.parent.scrollBy(0, -100);
    }
  }, [isMobile]);

  useEffect(() => {
    return () => {
      setDayPassPurchaseVerified(false);
    };
  }, []);

  return (
    <div id="day-pass-last-step" className={isQwaDashboard ? buyStyles.finalStepWrapper : ''}>
      {/* <img src={"https://qwa-assets.s3.us-east-2.amazonaws.com/success_blast.svg"} alt="celebrate" /> */}
      {!dayPassPurchaseVerified && !(isSubscriptionExpired || verificationFailed) ? (
        <>
          <QuattrLogoSpinner classes={{}} />
          <Typography className={buyStyles.buyBoxOuterHeader}>
            Please wait & do not refresh screen.
            <br />
            We are activating your day pass & ensuring you enjoy all its perks.
          </Typography>
        </>
      ) : (
        <>
          {isSubscriptionExpired ? (
            <>
              <Typography className={buyStyles.buyBoxOuterHeader} style={{ fontSize: '28px' }}>
                Your Day Plan has Expired!
              </Typography>
              <BuyOnePass isSubscriptionExpired handleContinue={handleContinue} />
            </>
          ) : verificationFailed ? (
            <>
              <Typography className={buyStyles.buyBoxOuterHeader} style={{ fontSize: '28px', color: '#F25F5C' }}>
                Oops.. Something Went Wrong!
              </Typography>
              <Typography className={buyStyles.buyBoxOuterHeader} style={{ fontSize: '20px' }}>
                Please refresh your screen to retry the Day Pass setup.
              </Typography>
              <Typography className={buyStyles.conditions}>
                Still not working? Please contact us at <u> support@quattr.com </u> & we will resolve it asap.
              </Typography>
            </>
          ) : (
            <div className={buyStyles.buyPassSuccessWrapper}>
              <img
                src={'https://qwa-assets.s3.us-east-2.amazonaws.com/success_blast.svg'}
                alt="celebrate"
                className={buyStyles.celebrateImage}
              />
              <Typography className={buyStyles.buyBoxOuterHeader} style={{ fontSize: '28px' }}>
                Your {plan_id == DAY_PASS_LITE_PLAN_ID ? 'Day Pass' : 'Day Pass'} is Activated Successfully!
              </Typography>
              <Typography className={buyStyles.buyBoxOuterHeader}>
                Valid till {validTillDate || 'DD-Mon-YYYY HR:MM'} {tz || ''}
              </Typography>
              <div className={`center-align ${buyStyles.successActionBox}`}>
                <Typography className={buyStyles.buyBoxOuterHeader} style={{ fontSize: '18px' }}>
                  You can now enjoy the perks of your pass on Quattr AI Tools*.
                </Typography>
                <Typography className={buyStyles.conditions}>
                  *Fair usage policy applies. Read{' '}
                  <span
                    style={{ textDecorationLine: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                      // window.parent.postMessage({ action: 'redirectURL', url: '/content-ai/terms', newTab: true }, '*');
                      window.open('/content-ai/terms');
                    }}
                  >
                    terms of use
                  </span>{' '}
                  for more.
                </Typography>
                <Button
                  onClick={() => {
                    trackAnalyticsEvent({
                      eventName: 'Clicked on Close & Continue',
                      payload: {
                        label: 'Clicked on Close & Continue',
                        ...(toolMeta || {}),
                      },
                    });
                    if (handleContinue) {
                      handleContinue();
                    }
                  }}
                  style={isMobile ? { width: '100%' } : { minWidth: '500px' }}
                  className={`${questionStyles.buttonOption} mt-15`}
                >
                  Close & Continue
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
